'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
export default (({
  children
}) => /*#__PURE__*/_jsx("div", {
  className: "subtitle",
  children: children
}));